import React, { useRef, useEffect, useState } from 'react';
import columnClasses from '../columns.css';
import Select from 'react-select';
import { OptionCustomer } from '../../../UI/select';
import { customStylesContact } from '../../../UI/select-styles';
import DataTableInput from '../../../Input/input';
import { menuPlacement, menuPlacementR1 } from '../selectHelper';

const propsAreEqual = (prev, next) => {
    return prev.focus === next.focus
        && prev.active === next.active
        && prev.row === next.row;
}

const Classification = ({ coords, row, width, classifications, disabled, isRuleFound, focus, active, elementFocused, isR1, handleClassification }) => {
    const classificationActiveInput = useRef(null);
    const classificationPassiveInput = useRef(null);
    const [mouseActive, setMouseActive] = useState(false);

    useEffect(() => {
        if (!disabled) {
            if (!active)
                setMouseActive(false);
            if (classificationPassiveInput.current)
                classificationPassiveInput.current.blur();
            if (classificationActiveInput.current) {
                if (active)
                    classificationActiveInput.current.focus();
            }
        }
    }, [active, classificationActiveInput, classificationPassiveInput])

    const selectTemplateClicked = (elem) => {
        setMouseActive(true);
        elementFocused();
    }

    const onSelectClassification = (contactValue) => {
        handleClassification(contactValue, row);
    }

    const classificationSelectKeyDown = e => {
        if (e.key === 'Backspace' || e.key === 'Delete') {
            onSelectClassification(null);
        }
    }

    const classificationValue = (row.Coding.length && row.classificationId && !isRuleFound(row)) ? classifications.find(item => item.value === row.classificationId) : null;
    if ((active !== true || disabled)) {
        return <DataTableInput
            inputElementType="text"
            value={classificationValue ? classificationValue.label : `Select...`}
            onClick={(e) => { if (!disabled) selectTemplateClicked(e.target) }}
            onFocus={elementFocused}
            // elementRef={accountInputTemplate}
            disabled={disabled}
            loading={mouseActive}
        />
    } else {
        return <Select
            name={`${row.BankDataGUID}_classification`}
            ref={classificationActiveInput}
            onChange={(value) => onSelectClassification(value)}
            value={classificationValue}
            isClearable={false}
            isDisabled={disabled}
            onFocus={elementFocused}
            isOptionDisabled={(option) => option.isActive === false}
            blurInputOnSelect
            closeMenuOnSelect
            placeholder={row.Coding.length > 1 ? '' : 'Select...'}
            components={{ Option: OptionCustomer }}
            options={classifications}
            styles={customStylesContact}
            maxWidth={width}
            className={columnClasses.inputElement}
            menuPortalTarget={!isR1 ? document.getElementById('DataTable') : ''}
            defaultMenuIsOpen={mouseActive}
            onKeyDown={classificationSelectKeyDown}
            menuPlacement={isR1 ? menuPlacementR1(coords.x, window.innerHeight * 0.38, 'bottom') : menuPlacement(coords.x, window.innerHeight * 0.38, 'auto')}//0.38 is comming from max Heigth of menu(in this case customStylesAcc.menulist.maxHeight is 38vh)
        />
    }
}

export default React.memo(Classification, propsAreEqual);


// WEBPACK FOOTER //
// ./src/components/TransactionList/Columns/Classification/classification.js